import React from 'react';

function Arrow(props) {
    const className = props.className;
    const fill = props.fill;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
            className={className}
        >
            <path 
                d="M0.848324 7.28856L7.25231 0.884579C7.64529 0.491599 8.28244 0.491599 8.67542 0.884579C9.0684 1.27756 9.0684 1.91471 8.67542 2.30769L3.98927 6.99383L14.4404 6.99383C14.9961 6.99383 15.4467 7.44436 15.4467 8.00012C15.4467 8.55588 14.9961 9.00641 14.4404 9.00641L3.98927 9.00641L8.67542 13.6926C9.0684 14.0855 9.0684 14.7227 8.67542 15.1157C8.28244 15.5086 7.64529 15.5086 7.25231 15.1157L0.848324 8.71167C0.455344 8.31869 0.455344 7.68154 0.848324 7.28856Z" 
                fill={fill}
            />
        </svg>
    )
};

export default Arrow;